<form id="questionnaire" [formGroup]="this.questionnaireForm" (ngSubmit)="this.saveQuestionnaire()">
           
    @if(this.title){
        <div id="questionnaire_title">{{this.title}}</div>
    }
    
    <div id="questionnaire_groups">
        @for(group of this.model.scDataGroups; track $index){

            <div class="questionnaire_group">
                <div class="questionnaire_group_name">{{group.name}}</div>
                <div class="questionnaire_fields">

                    @for(field of group.scdatafields; track $index){

                        @if(this.fieldsVisibility.get(field.code)){

                            <div class="questionnaire_field">                                        
                                <marv-field [label]="field.name" [inline]="false" icon="help-circle-outline">                                        
                                    <div class="questionnaire_field_input">
                                        @switch (field.type) {

                                            @case ('BOOLEAN') {
                                                <marv-select 
                                                    [formName]="field.code"
                                                    [items]="this.booleanOptions" 
                                                    [disabled]="this.disabledForm"
                                                    />    
                                            }

                                            @case ('STRING') {

                                                @if(this.shouldUseTextArea(field)){
                                                    <marv-textarea                                                                                                            
                                                        [formName]="field.code" 
                                                        [withSpeechToText]="true"
                                                        [disabled]="this.disabledForm"
                                                        />
                                                }
                                                @else{
                                                    <marv-input 
                                                        type="text"                                                            
                                                        [formName]="field.code" 
                                                        [withSpeechToText]="true" 
                                                        [disabled]="this.disabledForm"
                                                        />
                                                }

                                            }
                                                                                        
                                            @case ('INTEGER') {
                                                <marv-input 
                                                    type="number"                                                   
                                                    [formName]="field.code" 
                                                    [withSpeechToText]="true" 
                                                    [disabled]="this.disabledForm"
                                                    />
                                            }
                                            
                                            @case ('ENUM') {                                                    
                                                <marv-select 
                                                    [formName]="field.code"
                                                    [items]="this.mapOptions.get(field.code) || []" 
                                                    [disabled]="this.disabledForm"
                                                    />                                                        
                                            }
                                            
                                            @case ('MCQ') {
                                                <marv-select 
                                                    [formName]="field.code"
                                                    [items]="this.mapOptions.get(field.code) || []" 
                                                    [multiple]="true"
                                                    [disabled]="this.disabledForm"
                                                    />    
                                            }
                                            
                                            @case ('PHOTO') {
                                                <marv-input-file               
                                                    [formName]="field.code"                                                    
                                                    [(file)]="this.fieldsPhotos[field.code]"                                                                 
                                                    [acceptFiles]="this.photosFileExt" 
                                                    icon="image-outline"
                                                    [showBtnClearInput]="true"
                                                    [disabled]="this.disabledForm"
                                                    />
                                                @if(this.fieldsPhotos[field.code] && (this.fieldsPhotos[field.code].base64 || this.fieldsPhotos[field.code].url)){
                                                    <div class="questionnaire_photo_preview">
                                                        <ion-thumbnail>
                                                            @if(this.fieldsPhotos[field.code] && this.fieldsPhotos[field.code].base64){
                                                                <img [src]="this.fieldsPhotos[field.code].base64"/>
                                                            }
                                                            @else{
                                                                <img [src]="this.fieldsPhotos[field.code].url"/>
                                                            }
                                                        </ion-thumbnail>
                                                    </div>
                                                }                                                
                                            }
                                                                                        
                                            @case ('DOUBLE') {
                                                <marv-input 
                                                    type="number" 
                                                    [formName]="field.code" 
                                                    [withSpeechToText]="true" 
                                                    [disabled]="this.disabledForm"
                                                    />
                                            }
                                            
                                            @case ('DATE') {
                                                <marv-input-date                                                        
                                                    [formName]="field.code"                                                                                              
                                                    [withSpeechToText]="true" 
                                                    [disabled]="this.disabledForm" 
                                                    />  
                                            }

                                        }
                                    </div>
                                </marv-field>
                            </div>
                        }

                    }

                </div>
            </div>
        }
    </div>
    
    <ion-grid id="footer_questionnaire">
        <ion-row class="ion-justify-content-around">
            @if(!this.disabledForm){
                <ion-col size="auto">
                    <marv-button type="submit" label="{{ 'VALIDATE' | translate }}" icon="checkmark-outline" color="primary" [isFetching]="this.isFetchingValidation"/>
                </ion-col>
            }
            <ion-col size="auto">
                <marv-button type="button" label="{{ 'CLOSE' | translate }}" icon="close-outline" color="secondary" (click)="this.close()"/>
            </ion-col>
        </ion-row>
    </ion-grid>
    
</form>